var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _line, _line2, _polygon8, _line3, _line4, _polygon9, _polygon10, _line5, _line6, _polygon11, _line7, _line8, _line9, _line10, _polygon12, _line11, _line12, _line13, _line14, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatiment4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "batiment_4",
    "data-name": "batiment 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2392.51 1942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6eaed;}.cls-2,.cls-3{fill:#b5bec4;}.cls-3,.cls-6{opacity:0.35;}.cls-4{fill:#433f82;}.cls-5,.cls-6{fill:#3d356b;}.cls-7,.cls-9{fill:#d5d1db;}.cls-10,.cls-7,.cls-8,.cls-9{stroke:#4c4b54;}.cls-10,.cls-11,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-7,.cls-8{stroke-width:7px;}.cls-8{fill:#4c4b54;}.cls-11,.cls-9{stroke-width:10px;}.cls-10,.cls-11{fill:none;}.cls-10{stroke-width:6px;}.cls-11{stroke:#22224c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "batiment 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.51 1464 896.51 1942 2392.51 1080 2392.51 731 1569.51 258 1357.51 373 971.51 0 2.51 565 2.51 1080 75.51 1121.38 75.51 1464"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.51 565 896.51 1080 896.51 1942 75.51 1464 75.51 1122 2.51 1080 2.51 565"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1870.51 517 896.51 1080 896.51 1942 2392.51 1080 2392.51 731 1870.51 1033 1870.51 517"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2.51 1080 896.51 1592.44 1870.51 1033 1870.51 517 971.51 0 2.51 565 2.51 1080"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2.51 565 896.51 1080 896.51 1592 2.51 1079 2.51 565"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1870.51 517 1870.51 1033 896.51 1592 896.51 1079 1870.51 517"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1197.51 1763.5 1197.11 1511 1497.51 1338 1497.51 1588.02 1197.51 1763.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1271.94,
    y1: 1467.9,
    x2: 1271.94,
    y2: 1719.96
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1421.23,
    y1: 1381.93,
    x2: 1421.23,
    y2: 1632.64
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1336.21 1682.37 1357.25 1670.06 1357.25 1418.77 1336.21 1430.89 1336.21 1682.37"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1322.01,
    y1: 1550.5,
    x2: 1322.01,
    y2: 1591.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1370.01,
    y1: 1522,
    x2: 1370.01,
    y2: 1563
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1121.51 1382 1121.51 1123 1569.51 865 1569.51 1123 1121.51 1382"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1646.01 1079 1646.01 820 1720.01 776 1720.01 1034 1646.01 1079"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1271.94,
    y1: 1036.37,
    x2: 1271.94,
    y2: 1295.03
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1421.23,
    y1: 950.39,
    x2: 1421.23,
    y2: 1208.72
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1569.51 1467 1569.51 1295 2316.51 865 2316.51 1036 1569.51 1467"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1719.94,
    y1: 1208.37,
    x2: 1718.94,
    y2: 1381.03
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2016.94,
    y1: 1037.37,
    x2: 2015.94,
    y2: 1210.03
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 2166.94,
    y1: 951.37,
    x2: 2165.94,
    y2: 1124.03
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 1869.23,
    y1: 1122.39,
    x2: 1868.23,
    y2: 1294.72
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "822.51 1808 822.51 1636 148.51 1253 148.51 1424 822.51 1808"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 672.09,
    y1: 1549.37,
    x2: 673.09,
    y2: 1722.03
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 375.09,
    y1: 1378.37,
    x2: 376.09,
    y2: 1551.03
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 225.09,
    y1: 1292.37,
    x2: 226.09,
    y2: 1465.03
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 522.79,
    y1: 1463.39,
    x2: 523.79,
    y2: 1635.72
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "2.51 584.64 896.51 1104.62 1870.51 538.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatiment4);
export default __webpack_public_path__ + "static/media/batiment_4.48f6e0d186df1d242b6dd586ea651897.svg";
export { ForwardRef as ReactComponent };